<template>
  <div id="box">
<!--    <a-card style="box-sizing:border-box;border-radius: 0 !important;">-->
      <!--      <div class="wps" :style="{background:'#f5f5f5'}">-->
      <!--        &lt;!&ndash;        <img src="images/93750.png">&ndash;&gt;-->
      <!--        <div class="biaoti" style="cursor:pointer" @click="homepay">-->
      <!--          <div class="boxw">-->
      <!--            <img :src="configdata.logoimg" width="100px" height="100px"-->
      <!--                 style="margin-top: -14px;  padding-right: 10px"/>-->
      <!--          </div>-->
      <!--          {{ configdata.projectname }}-->
      <!--        </div>-->
      <!--      </div>-->
<!--    </a-card>-->
    <Header></Header>

<!--    <div style="height: 80px"></div>-->


    <div class="box_info">
      <div id="searchbar">
        <div id="leftbar">
          <div class="baritem">信用代码：{{ nowcompany }} <i style="margin: 0 10px;"></i> 登录手机号：{{ nowemail }}</div><span style="margin: 0 10px;color:#409EFF;cursor: pointer" @click="userinfo()">修改用户信息</span>
        </div>


        <div>
<!--          <a-button type="primary" style="margin-right: 10px" @click="querylist">查询订单</a-button>-->


          <a-button type="danger" @click="logout">退出登录</a-button>
        </div>

      </div>
      <!--      -->
      <a-layout>
        <a-layout-content :style="{ background: '#fff',  margin: 0, minHeight: '280px' }">

          <a-table :columns="columns" :row-key="pattern" :data-source="datas" :pagination="pagination" :loading="loading" :bordered="true" @change="handleTableChange">

            <template slot="company" slot-scope="datas, record">
              <a-tooltip placement="top">
                <template slot="title"> <span>{{record.company}}</span> </template>
                <span style="display:block;width: 100px;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{record.company}}</span>
              </a-tooltip>
            </template>

            <template slot="totalfee" slot-scope="datas, record">
              <a-tooltip placement="top">
                <template slot="title"> <span>{{ record.ordertype == 1  ? record.totalfee :record.daibanfee}}</span> </template>
                <span style="display:block;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{ record.ordertype == 1  ? record.totalfee :record.daibanfee}}</span>
              </a-tooltip>
            </template>

            <template slot="addtime" slot-scope="datas, record">
              <a-tooltip placement="top">
                <template slot="title"> <span>{{record.addtime}}</span> </template>
                <span style="display:block;width: 90px;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;cursor: pointer">{{record.addtime}}</span>
              </a-tooltip>
            </template>

            <template slot="sactions" slot-scope="datas, record">
              <span>开票</span>
            </template>

            <template slot="ordertype" slot-scope="datas, record">
              <span v-if="record.ordertype == 1" style="color: #409EFF">KEY订单</span>
              <span v-if="record.ordertype == 2" style="color: #67C23A">制图服务</span>
              <span v-if="record.ordertype == 3" style="color: #E6A23C">服务续费</span>
              <span v-if="record.ordertype == 4" style="color: #E6A23C">人工制图</span>
            </template>

            <template slot="actions" slot-scope="datas, record">
              <div class="li" v-if="record.status == 0">订单生成</div>
              <div class="li" v-if="record.status == 1">支付中</div>
              <div class="li" v-if="record.status == 2">支付成功</div>
              <div class="li" v-if="record.status == 3">支付失败</div>
              <div class="li" v-if="record.status == 4">已撤销</div>
              <div class="li" v-if="record.status == 5">已退款</div>
              <div class="li" v-if="record.status == 6">订单关闭</div>
              <div class="li" v-if="record.status == 7">退款审核中</div>
              <div class="li" v-if="record.status == 8">退款成功</div>
              <div class="li" v-if="record.status == 9">退款失败</div>
              <div class="li" v-if="record.status == 10">退款中</div>
              <div class="li" v-if="record.status == 11">退款成功</div>
              <div class="li" v-if="record.status == 12">退款失败</div>
              <div class="li" v-if="record.status == 13">退款关闭</div>
            </template>

            <template slot="action" slot-scope="datas, record">
              <a href="javascript:;" @click="showModal(record.id)" v-if="record.ordertype == 1 && record.status == 2">申请退款</a>
              <a href="javascript:;" @click="showKuaidi(record)" v-if="record.expresscompany != '' && record.ordertype == 1 && record.status == 2" style="margin-left: 20px">查看快递</a>
            </template>
          </a-table>
        </a-layout-content>
      </a-layout>
      <!--      -->
      <a-modal title="退款原因" :visible="visible" @ok="handleOk" @cancel="handleCancel">
        <div class="financeitem"><span>本订单明细如下：</span></div>
        <div  class="financeitem">订单总金额：{{ refunddata.totalfee }} </div>
<!--        <div  class="financeitem">其中包含key：{{ refunddata.totalnum }}个，key总额：{{refunddata.keyfee }}，代办服务费总额：{{ refunddata.daibanfee }}，第三方邮寄费总额：{{ refunddata.expressfee }}</div>-->
        <div  class="financeitem">已使用数量：{{ refunddata.usenum }}个</div>
        <div  class="financeitem">可退费金额：{{ refunddata.refundfee }}</div>
        <div   style="margin-top: 5px;padding: 5px">
          <a-input type="textarea" placeholder="请输入退款原因" v-model="textarea"></a-input>
        </div>
      </a-modal>
    </div>

    <el-dialog title="快递信息" :visible.sync="dialogVisible" width="40%" >
      <div class="block" style="height: 500px;overflow-y: auto;">
        <el-timeline>
          <el-timeline-item :key="activity.id" v-for="(activity, index) in activities"  :timestamp="activity.acceptTime" placement="top">
            <el-card>
              <div>抵达城市：{{ activity.acceptAddress }}</div>
              <p style="color: #666;font-size: 12px;">{{ activity.remark }}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <Footer></Footer>
  </div>
</template>

<script>
import {
  Company_getInfo,
  mail_send,
  mallOrderdata_apply_refund, mallOrderdata_getrestnum,
  order_orderlist,
  refund_refund,
  SF_query_by_expressno
} from '@/api/manage' // 接口
import {Carousel} from 'ant-design-vue'
import Pagination from '@/components/Pagination'
import {conf_list, getPriceBydaiban, refund_getrestnum, userlogin} from "../../api/manage";
import Header from "@/components/heard/index.vue";
import Footer from "@/components/footer/index.vue";
import {removeToken} from "@/utils/auth";


export default {
  name: 'paytest',
  props: {},
  components: {Carousel, Pagination, Header, Footer},
  data() {
    return {
      nowcompany: '',
      nowemail: '',
      listLoading: false,
      textarea: '',
      yscode: '',
      dialogVisible:false,
      sdisableds: false,
      timer: 60,
      mailbox: '',
      mailboxcode: '',
      datas: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        {
          title: 'ID',
          align: "center",
          dataIndex: 'id',
        },
        {
          title: '单位名称',
          dataIndex: 'company',
          scopedSlots: { customRender: "company" },
        },
        {
          title: '信用代码',
          dataIndex: 'yscode'
        },
        {
          title: '购买数量',
          align: "center",
          dataIndex: 'totalnum'
        },
        {
          title: '消费金额',
          align: "center",
          dataIndex: 'totalfee',
          scopedSlots: { customRender: "totalfee" },
        },
        {
          title: '购买时间',
          dataIndex: 'addtime',
          scopedSlots: { customRender: "addtime" },
        },
        {
          title: '联系人',
          align: "center",
          dataIndex: 'name'
        },
        {
          title: '联系电话',
          align: "center",
          dataIndex: 'phone'
        },
        {
          title: '是否开票',
          key: 'sactions',
          align: "center",
          scopedSlots: {customRender: 'sactions'},
        },
        {
          title: '订单类型',
          key: 'ordertype',
          align: "center",
          scopedSlots: {customRender: 'ordertype'},
        },
        {
          title: '状态',
          key: 'actions',
          align: "center",
          scopedSlots: {customRender: 'actions'},
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: {customRender: 'action'},
        }
      ],
      pattern: '/^\\w+((-\\w+)|(\\.\\w+))*@[A-Za-z0-9]+((\\.|-)[A-Za-z0-9]+)*\\.[A-Za-z0-9]+$/',
      imgurl: require('@/assets/images/key.png'),
      imgbg: require('@/assets/images/topbg.jpeg'),
      mchAppList: [], // app列表
      appId: '2021003131636388', // 已选择的appId
      appPaywayList: ['ALI_QR'], // 商户app支持的支付方式
      currentWayCode: 'ALI_QR', // 以何种方式进行支付，默认是微信二维码
      currentPayDataType: '', // 支付参数
      mchOrderNo: '', // 模拟商户订单号
      authCode: '', // 条码的值
      companyyscode: '',
      paytestAmount: '0.01', // 支付金额，默认为0.01
      amountInput: false, // 自定金额输入框是否展示
      noConfigText: false, // 尚无任何配置分割线提示文字
      divisionMode: 0, // 订单分账模式
      orderTitle: '接口调试', // 订单标题
      value: 1,
      checked: false,
      checkeddef: true,
      sendmethod: 1,
      valuests: null,
      outtime: null,
      disabledlook: false,
      activities:[],
      visibletongzhi: false,
      visiblelook: false,
      valueaw: 2,
      valiBtn: '同意条款',
      ModalText: '阅读协议，哈哈首科大厦大家安康',
      visible: false,
      companyname: '',
      confirmLoading: false,
      radioStyle: {
        cursor: 'pointer',
        marginleft: '10px',
        height: '30px',
        lineHeight: '30px',
        color: '#132b75',
      },
      page: 1,
      pagesize: 10,
      mpd: null,
      vshow: true,
      isshowFooter: false,
      tobonumber: null,
      tobonum: null,
      Byyouji: null,
      number: {
        value: 11,
      },
      year: null,
      month: null,
      dates: null,
      btnTime: null,
      projectname: '',
      xmalimg: '',
      usbkeyimg: '',
      maile: '',
      companytitle: '',
      notice: '',
      imgurlas: '',
      refunddata: {},
      configdata: {}
    }
  },
  created() {
    var configdata =  JSON.parse(localStorage.getItem('configdata'))
    this.configdata = configdata
    // conf_list({}).then(response => {
    //   this.configdata = response.data
    // })

    Company_getInfo({}).then(response => {
      // console.log(response.user,'response+++++++++')
      this.nowcompany = response.user.company == null ? '':response.user.company + response.user.yscode == null ? '':response.user.yscode
      this.nowemail = response.user.phonenumber == null ? '':response.user.phonenumber
      this.phone =  response.user.phonenumber == null ? '':response.user.phonenumber
      this.yscode =  response.user.yscode == null ? '':response.user.yscode
      order_orderlist({
        phone: this.phone,
        yscode: this.yscode,
        page: this.page,
        pagesize: this.pagesize,
      }).then(response => {
        // console.log(response)
        this.datas = response.data.data
      })
    })
  },
  methods: {
    userinfo(){
      this.$router.push('/userinfo');
    },
    homepay() {
      this.$router.push('/');
    },
    handleSubmits() {
      this.$router.push('/');
    },
    showModal(e) {
      // mallOrderdata/getrestnum
      mallOrderdata_getrestnum({id: e}).then(response => {
        this.refunddata = response.data
        this.Id = e
        this.textarea = ''
        this.visible = true;
      })
    },
    showKuaidi(row){

      SF_query_by_expressno({expressno:row.expressno}).then((response) => {
        // console.log(response.data.routes)
        this.activities = response.data.routes
        if(response.data.routes.length == []){
          this.dialogVisible = false
          this.$message.info('暂无快递信息');
        }else{
          this.dialogVisible = true
        }
      });

    },
    handleTableChange(e) {
      this.page = e.current
      this.pagination.current = e.current


      order_orderlist({
        phone: this.phone,
        yscode: this.yscode,
        page: this.page,
        pagesize: this.pagesize,
      }).then(response => {
        // console.log(response)
        this.datas = response.data.data
      })

    },
    verification(e) {
      var mailbox = this.mailbox
      if (!/^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(mailbox)) {
        this.$message.info('请填写正确邮箱！！！');
        return false
      } else {
        mail_send({email: mailbox}).then(response => {
        })
      }
    },
    logout() {
      this.$confirm('确定退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            removeToken()
            localStorage.removeItem("setToken");
            localStorage.removeItem("companyinfo");
            localStorage.removeItem("configdata");
            this.$router.push("/login")
          })
          .catch(() => {

          })
    },
    querylist() {

      order_orderlist({
        phone: this.phone,
        yscode: this.yscode,
        page: this.page,
        pagesize: this.pagesize,
      }).then(response => {
        this.datas = response.data.data
        this.pagination.total = response.data.total
      })
    },
    onChange1(e) {
      this.sendmethod = e.target.checked ? 1 : 2
      this.mpd = e.target.checked
      console.log(this.sendmethod)
      console.log(e.target.checked)
    },
    onChangeqw() {
      console.log('asad')
      this.disabledlook = false
    },

    handleOk(e) {
      console.log(typeof (this.refunddata.statecode));
      switch (this.refunddata.statecode) {
        //证书系统未查询到此订单
        case 404:
          this.$message.info(this.refunddata.message);
          return false
        break;
          //证书系统查询到此订单已经全部消费完
        case 405:
          this.$message.info(this.refunddata.reason);
          return false
          break;
        case 0:
          if (this.textarea == '') {
            this.$message.info('退款原因不能为空！');
            return false
          } else {
            // mallOrderdata/apply_refund
            // mallOrderdata_apply_refund
            mallOrderdata_apply_refund({
              id: this.Id,
              refundmessage: this.textarea,
              // phone: this.phone,
              // yscode: this.yscode,
              // page: this.page,
              // pagesize: this.pagesize,
            }).then(response => {
              if (response.code == 0) {
                this.$message.info('信息提交成功');
                this.textarea = ''
                this.visible = false;
                order_orderlist({
                  phone: this.phone,
                  yscode: this.yscode,
                  page: this.page,
                  pagesize: this.pagesize,
                }).then(response => {
                  this.datas = response.data.data
                  this.pagination.total = response.data.total
                })
              }
            })
          }
          break;
      }
    },
    handleCancel(e) {
      this.textarea = ''
      this.visible = false;
    },

  }
}
</script>

<style lang="css" scoped>
@import './payTest.css';

/*html, body, #app, #root{background: #f5f5f5 !important;}*/

/*.son{*/
/*  position: absolute;*/
/*  left: 52px;*/
/*}*/
b {
  color: #333;
}

.wps {
  display: flex;
  justify-content: center;
  /*background: #132b75;*/
  height: 110px;
  line-height: 110px;
  /*padding: 25px 0;*/
  text-align: center;
  /*background: -webkit-radial-gradient(circle, #fff, #64d1dd, #e86a43);  */
  /*background:white; background-image: linear-gradient(90deg, rgba(200,0,0,.5) 50%, transparent 0), linear-gradient( rgba(200,0,0,.5) 50%, transparent 0); background-size: 30px 30px;*/
}

.boxw {
  display: block;
  width: 100px;
  height: 100px;
  font-size: 46px;
  font-weight: 500;
  font-family: Microsoft YaHei UI Light;
  border-radius: 15px;

}


.biaoti {
  display: flex;
  flex-direction: row;
  font-size: 35px;
  font-weight: bold;
  text-align: center;
  font-family: "黑体";
}

.shangpinbiaoti {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
}

#searchbar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;

}
.financeitem{padding: 5px;border-bottom: #ccc dashed 1px;}
#leftbar {
  display: flex;
  flex-direction: row;
}

.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide img {
  border: 5px solid #fff;
  display: block;
  margin: auto;
  max-width: 60%;
}

.ant-carousel >>> .slick-thumb {
  bottom: -45px;
}

.ant-carousel >>> .slick-thumb li {
  width: 60px;
  height: 45px;
}

.ant-carousel >>> .slick-thumb li img {
  width: 100%;
  height: 100%;
  filter: grayscale(100%);
}

.ant-carousel >>> .slick-thumb li.slick-active img {
  filter: grayscale(0%);
}

#ok .ant-form-item-label label::after {
  content: '';
  position: relative;
  top: -0.5px;
  margin: 0 8px 0 2px;
}

.displayssssss {
  display: flex;
  flex-direction: column;
  height: 100px;
  position: relative;
}

.displayssssss p {
  float: right;
  width: 300px;
  text-align: right;
  position: absolute;
  right: 0;
}

/*box_info*/

.box_info {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 25px 30px;
  box-sizing: border-box;

}
</style>
